module.exports = __webpack_public_path__ + "static/04-08f4aefbe7edff6dc7a9e51eb425afda.jpg";